export const ROUTE_TYPE = {
  DIVIDER: 1,
  MENU_ITEM: 2,
  SUB_MENU: 3,
};